'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import PropTypes from 'prop-types';
import React from 'react';
import SVGTextIconStyle from './SVGTextIconStyle';
import SVGWrapper from './SVGWrapper';

var SVGIcon = function SVGIcon(props) {
  var wrapperProps = props.wrapperProps,
      icon = props.icon,
      innerProps = _objectWithoutProperties(props, ["wrapperProps", "icon"]);

  return React.createElement(SVGWrapper, wrapperProps, React.createElement(SVGTextIconStyle, innerProps, icon));
};

SVGIcon.propTyes = {
  wrapperProps: PropTypes.node,
  icon: PropTypes.string
};
export default SVGIcon;